<template>


  <form @submit.prevent="submit"
        class="space-y-4 lg:space-y-8"
  >

    <header class="col-span-6">
      <h3 class="text-3xl ">{{ headerText }}</h3>
    </header>


    <section class="grid grid-cols-2 gap-6 divide-y divide-x-0 lg:divide-x lg:divide-y-0  divide-slate-300">

      <section class="col-span-2 lg:col-span-1 space-y-3">
        <h4 class="text-xl">{{ localise.rfb_header_contact[lang] }}</h4>
        <div>
          <label class="block text-sm font-medium"
                 for="fullname"
          >{{ localise.input_label_fullname[lang] }}
            <span class="text-red-700 text-xs">*</span>
          </label>
          <input v-model="fullname"
                 autocomplete="family-name"
                 class="w-full input-md"
                 required
                 type="text"
                 @input="validate"
          >
        </div>
        <div>
          <label class="block text-sm font-medium"
                 for="emailaddress"
          >{{ localise.input_label_email[lang] }}
            <span v-show="mailcopy"
                  class="text-red-700 text-xs"
            >*</span>
          </label>
          <input v-model="emailaddress"
                 autocomplete="email"
                 type="email"
                 :required="mailcopy"
                 class="w-full input-md"
                 @input="validate"
          >
        </div>


        <div>
          <label for="phone"
                 class="block text-sm font-medium"
          >{{ localise.input_label_phone[lang] }}
          </label>
          <input v-model="phone"
                 type="text"
                 autocomplete="phone"
                 class="w-full input-md"
                 :placeholder="localise.input_placeholder_phone[lang]"
          >
        </div>

        <div>
          <label for="companyNumber"
                 class="block text-sm font-medium"

          >{{ localise.input_label_customer_id[lang] }}
          </label>

          <aside class="flex items-center justify-between">
            <input v-model.number.trim="companyNumber"
                   type="text"
                   autocomplete="company"
                   class="w-full input-md flex-grow"
                   maxlength="5"
            >
            <button type="button"
                    class="button-set"
                    @click="showCustomerIdSection = !showCustomerIdSection"
            >?
            </button>

          </aside>

          <transition name="fade">
            <article
                v-show="showCustomerIdSection"
                class="w-full p-3 bg-slate-100"
            >
              {{ localise.msg_customer_id[lang] }}
            </article>
          </transition>

        </div>

      </section>


      <section class="col-span-2 lg:col-span-1 pl-0 lg:pl-6 pt-3 lg:pt-0 space-y-3">
        <h4 class="text-xl">{{ localise.rfb_header_destination[lang] }}</h4>
        <div>

          <label for="company"
                 class="block text-sm font-medium"
          >{{ localise.input_label_company[lang] }} <span class="text-red-700 text-xs">*</span>
          </label>


          <input v-model="company"
                 type="text"
                 autocomplete="company"
                 class="w-full input-md"
                 required
          >
        </div>

        <div>
          <label for="street"
                 class="block text-sm font-medium"
          >{{ localise.input_label_street[lang] }} <span class="text-red-700 text-xs">*</span>
          </label>
          <input v-model="street"
                 type="text"
                 autocomplete="street"
                 class="w-full input-md"
                 required
          >
        </div>
        <div>
          <label for="houseNumber"
                 class="block text-sm font-medium"
          >{{ localise.input_label_street_number[lang] }}
          </label>
          <input v-model="houseNumber"
                 type="text"
                 autocomplete="houseNumber"
                 class="w-full input-md"
          >
        </div>
        <div>
          <label for="cityZip"
                 class="block text-sm font-medium"
          >{{ localise.input_label_zip[lang] }} <span class="text-red-700 text-xs">*</span>
          </label>
          <input v-model="cityZip"
                 type="text"
                 autocomplete="houseNumber"
                 class="w-full input-md"
                 required
          >
        </div>
        <div>
          <label for="cityName"
                 class="block text-sm font-medium"
          >{{ localise.input_label_city[lang] }} <span class="text-red-700 text-xs">*</span>
          </label>
          <input v-model="cityName"
                 type="text"
                 autocomplete="houseNumber"
                 class="w-full input-md"
                 required
          >
        </div>
        <LangSelector :lang="lang"
                      @setcountry="setCountry"
        >
        </LangSelector>
      </section>

    </section>

    <search-database :lang="lang"
                     :header="localise.dbsearch_header[lang]"
                     @setnewpostext="(newText) => newPosText.value = newText"
    ></search-database>

    <position-maker :lang="lang"
                    :header="localise.rfb_header[lang]"
                    :subheader="localise.rfb_subheader[lang]"
                    @makeposition="makePosition"
                    :newpostext="newPosText.value"
    ></position-maker>

    <div>
      <label class="block text-sm font-medium"
             for="about"
      >{{ localise.textfield_label_message[lang] }}
      </label>
      <div class="mt-1">
            <textarea v-model="about"
                      rows="3"
                      class="mt-1 block w-full input-md"
            />
      </div>
    </div>

    <div>
      <div class="mt-4 space-y-4">
        <div class="flex items-start">
          <div class="flex h-5 items-center">
            <input v-model="datenschutz"
                   required
                   type="checkbox"
                   class="h-4 w-4 rounded border-slate-300 text-red-600 focus:ring-red-500 checked:bg-red-700"
                   @change="validate"
            >
          </div>
          <div class="ml-3 text-sm cursor-pointer"
               @click="datenschutz = !datenschutz"
          >
            <label for="datenschutz"
                   class="font-medium"
            >{{ localise.checkbox_label_privacy[lang] }}
              <span class="text-red-700 text-xs">*</span>
            </label>
            <br>
            <span class="text-slate-500 text-xs">{{ localise.checkbox_text_privacy[lang] }}<a :href="localise.checkbox_link_privacy[lang]">{{ localise.checkbox_link_privacy_label[lang] }}</a>.</span>
          </div>
        </div>
        <div>
          <div class="flex items-start">
            <div class="flex h-5 items-center">
              <input v-model="mailcopy"
                     type="checkbox"
                     class="h-4 w-4 rounded border-slate-300 text-red-600 focus:ring-red-500"
                     @change="validate"
              >
            </div>
            <div class="ml-3 text-sm cursor-pointer"
                 @click="mailcopy = !mailcopy"
            >
              <label for="mailcopy"
                     class="font-medium"
              >{{ localise.checkbox_label_send_email_copy[lang] }}
              </label>
              <br>
              <span class="text-slate-500 text-xs">{{ localise.checkbox_text_send_email_copy[lang] }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--  Submit button section -->
    <div class="grid grid-cols-6 gap-6">

      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <button type="submit"
                class=" group relative flex w-full justify-center rounded-md border border-transparent bg-red-600 py-2 px-4 text-sm font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                :disabled="!formIsValidated"
                :class="{'bg-green-600 hover:bg-green-600 focus:ring-green-500' : formsent,'bg-green-400 hover:bg-green-400 focus:ring-green-500' : senddata, 'bg-slate-400 hover:bg-slate-400 focus:ring-slate-500': !formIsValidated}"
        >
          {{ buttontext }}
        </button>
      </div>
      <transition name="fade">
      <aside class="col-span-6 lg:col-span-4"
             v-if="showNotification"
      >
        <div class="pointer-events-auto w-full max-w-5xl overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
          <div class="p-4">
            <div class="flex items-start">
              <div class="flex-shrink-0">
                <svg class="h-6 w-6 text-green-400"
                     fill="none"
                     viewBox="0 0 24 24"
                     stroke-width="1.5"
                     stroke="currentColor"
                     aria-hidden="true"
                >
                  <path stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <div class="ml-3 w-0 flex-1 pt-0.5">
                <p class="text-sm font-medium text-slate-900">{{ localise.msg_notification_success_header[lang] }}</p>
                <p class="mt-1 text-sm text-slate-500">{{ localise.msg_notification_success_text[lang] }}</p>
              </div>
              <div class="ml-4 flex flex-shrink-0">
                <button type="button"
                        class="inline-flex rounded-md bg-white text-slate-400 hover:text-slate-500 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                        @click="showNotification = !showNotification"
                >
                  <span class="sr-only">Close</span>
                  <svg class="h-5 w-5"
                       viewBox="0 0 20 20"
                       fill="currentColor"
                       aria-hidden="true"
                  >
                    <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </aside>
      </transition>
    </div>
  </form>

</template>
<script setup>

import {reactive, ref} from "vue";
import localise from "../lang/localize.json"
import LangSelector from "./forms/LangSelector.vue";
import SearchDatabase from "./forms/SearchDatabase.vue";
import PositionMaker from "./forms/PositionMaker.vue";

const props = defineProps({
  headerText: {
    type: String,
    default: localise.section_header_request_box.de
  },
  message: {
    type: String,
    default: ''
  },
  lang: {
    type: String,
    default: 'de'
  }
})

const fullname = ref('');
const company = ref('');
const street = ref('');
const houseNumber = ref('');
const companyNumber = ref('');
const cityZip = ref('');
const cityName = ref('');
const stateName = ref('');
const phone = ref('');
const country = ref('');
const emailaddress = ref('');
const datenschutz = ref(true);
const mailcopy = ref(false);
const formsent = ref(false);
const showCustomerIdSection = ref(false);
const subject = ref(props.message);
const about = ref('');
const senddata = ref(false)
const formIsValidated = ref(false)
const showNotification = ref(false)

const buttontext = ref(localise.btn_label_rfb_submit[props.lang])

const posItems = ref([])

const newPosText = reactive({value: ''})

const setCountry = (countryName) => {
  country.value = countryName
}

const setPosText = (newPosTextString) => {
  newPosText.value = newPosTextString
}

const makePosition = (newPosition) => {
  posItems.value.push(newPosition)
  validate()
}

const validate = () => {
  let formValidated = datenschutz.value
      && fullname.value.length > 0
      && emailaddress.value.length > 0
      && fullname.value.length > 0
      && company.value.length > 0
      && street.value.length > 0
      && companyNumber.value.length > 0
      && cityZip.value.length > 0
      && cityName.value.length > 0;


  formIsValidated.value = (mailcopy.value)
      ? formValidated && emailaddress.value.length > 0
      : formValidated
}

const submit = async () => {
  formsent.value = true;
  senddata.value = true;
  buttontext.value = localise.btn_text_sending_message[props.lang];

  fetch(
      'https://api.thermo-control.com/v1/send-contact-mail',
      {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        headers: {
          'Accept': 'application/json',
        },
        body: JSON.stringify({
          api_key: 'KAyAcRJZUacAYGRCeCfZXRAAAIQgAAEIACBxAggThJDyY0gAAEIQAACEIAABCAAgXoIIE7q',
          fullname: fullname.value,
          internal: "Verpackung senden",
          sender:'thermo',
          lang:props.lang,
          emailaddress: emailaddress.value,
          subject: subject.value,
          about: about.value,
          datenschutz: datenschutz.value,
          mailcopy: mailcopy.value,
          positions: posItems.value
        })
      }
  ).then(response => response.json())
      .then(data => {
        showNotification.value = true
        senddata.value = false;
        formsent.value = data.formsent;
        buttontext.value = (data.formsent) ? localise.btn_text_message_success[props.lang] : localise.btn_text_send_message[props.lang];
        setTimeout(() => {
          formsent.value = false;
          buttontext.value = localise.btn_text_send_new_message[props.lang];
        }, 600)
      })


  /*   const messages = JSON.parse(localStorage.getItem("messages"));
     const { name, phonenumber} = this;
     messages.push({
       name,
       phonenumber,
     });
     localStorage.setItem("messages", JSON.stringify(messages));*/
}

/** Provide Testdata to form


const setTrialData = () => {

  fullname.value = 'Daniel Körtvélyessy'
  company.value = 'thermo-control Körtvélyessy GmbH'
  street.value = 'Grünspechtweg'
  houseNumber.value = '19'
  companyNumber.value = '13200'
  cityZip.value = '13469'
  cityName.value = 'Berlin'
  stateName.value = 'Berlin'
  phone.value = '+491735779408'
  country.value = 'Deutschland'
  emailaddress.value = 'daniel@thermo-control.com'
  about.value = 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consequatur deserunt distinctio maxime mollitia nam nemo sequi sint sunt! Aliquid aperiam ipsa mollitia porro quaerat quam qui repellendus sint veritatis voluptatem?'

}

 */


</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}
</style>